import { localStorageKeys } from 'constants/localStorage';
const skeleton = {
  home: true,
  dashboard: true,
  planosGerais: true,
  relatorios: true,
  geolocalizacao: true,
  documentos: {
    exibir: false,
    salvar: false,
  },
  atividadesAgendadas: {
    excluir: false,
    editar: false,
  },
  ocorrencias: {
    editar: false,
    excluir: false,
  },
  correcoes: {
    incluir: false,
    editar: false,
    excluir: false,
  },
};
const stored = JSON.parse(localStorage.getItem(localStorageKeys.permissionContext));

const initialState = stored || skeleton;

export { initialState, skeleton };
